<script setup lang="ts">
import { onMounted } from 'vue';
import { type EnrollmentRow, searchTableColumns } from '@/types/EnrollmentTable';
import StudentLinkTable from '@/components/Reports/StudentLinkTable.vue';

defineProps<{
    searchResults: EnrollmentRow[],
    loading: boolean;
}>();

onMounted(() => {
    window.scrollTo(0, 0);
});

</script>
<template>
    <div class="search-results q-my-auto q-mx-xl">
        <div class="buttons text-right">
            <q-btn
                label="Go Back"
                class="back-btn fsum-button-dark-blue q-mb-md"
                no-caps
                :to="{ name: 'studentSearch' }"
            />
        </div>
        <StudentLinkTable
            :rows="searchResults"
            :columns="searchTableColumns"
            :loading="loading"
            :sort-by="searchTableColumns[0].name"
            :show-filters="false"
        />
    </div>
</template>
<style scoped>
</style>
